import React from 'react'
import { Route, RouteProps } from 'react-router'

import { useRoot } from '../atoms/RootProvider'
import { RedirectToLogin } from './RedirectToLogin'

interface ISecureRouteProps extends RouteProps {
  redirect?: boolean
}

export const SecureRoute: React.SFC<ISecureRouteProps> = ({
  redirect = true,
  path,
  exact,
  ...routeProps
}) => {
  const { auth } = useRoot()
  return (
    <Route
      path={path}
      exact={exact}
      render={() => {
        if (auth.isAuthenticated) {
          return <Route {...routeProps} />
        }
        return redirect ? <RedirectToLogin /> : null
      }}
    />
  )
}
